// vory
// Ivory FSC Mix Credit
// Ivory FSC Mix 70%
// Duplex
// Duplex FSC Mix Credit
// Duplex FSC Mix 70%
// Duplex (2S)
// Couche
// Forte
// Kraft
export enum PaperTypeEnum {
  Ivory = "Ivory",
  IvoryFSCMixCredit = "IvoryFSCMixCredit",
  IvoryFSCMix70 = "IvoryFSCMix70",
  Duplex = "Duplex",
  DuplexFSCMixCredit = "DuplexFSCMixCredit",
  DuplexFSCMix70 = "DuplexFSCMix70",
  Duplex2S = "Duplex2S",
  Couche = "Couche",
  Forte = "Forte",
  Kraft = "Kraft",
  Other = "Other",
}
